import '.a8{position:fixed;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.bw{left:0px;}.ssr-plugin'
import '.bx{right:0px;}.ssr-plugin'
import '.by{bottom:0px;}.ssr-plugin'
import '.hp{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hq{z-index:998;}.ssr-plugin'
import '.hr{transition:opacity 0.3s ease;}.ssr-plugin'
import '.x{height:100vh;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.hs{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.ht{z-index:999;}.ssr-plugin'
import '.j{display:flex;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.c9{padding:1.5rem;}.ssr-plugin'
import '.hu{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.aw{flex-shrink:0;}.ssr-plugin'
import '.c2{flex:1;}.ssr-plugin'
import '.ai{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a8 bv bw bx by hp hq hr"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a8 bv x a0 ah hs ht j v"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="j r a1 c9 hu aw"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c2 ai c9"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
